module.exports = __webpack_public_path__ + "static/media/singapore_skills_logo.bfe5e0b4.webp";